<template>
  <div class="stock-manage-bd tb" style="padding: 0" v-if="funcView.stock_device_list || funcView.be_stock_device_list">
    <custom-tab v-model="tab" @change="changeTab" :list="tabList"></custom-tab>
    <!-- 已入库 -->
    <div v-if="tab === '2'" class="stock-wrap">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-button v-if="funcView.stock_bulk_transfer" type="primary" @click="batchTransferDialog">
              <i class="icon icon-transfer"></i>
              &ensp;{{ funcView.stock_bulk_transfer }}
            </el-button>
            <el-button v-if="funcView.stock_batch_renovate" type="primary" @click="batchRenovateDialog">
              <i class="icon icon-piliangtianjia"></i>
              &ensp;{{ funcView.stock_batch_renovate }}
            </el-button>
          </el-form-item>
          <!-- 导出 -->
          <el-form-item style="float: right; margin-right: 0" v-if="funcView.stock_device_export">
            <el-button class="table-set" style="vertical-align: top" @click="exportTable">
              <i class="icon icon-daochu"></i>
            </el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('dms_stock_manage.jshmodemSNrkdh')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
          <!-- 高级搜索 -->
          <el-form-item style="float: right">
            <switch-button :link="link"></switch-button>
          </el-form-item>
        </el-form>
      </div>
      <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
        <el-form :inline="true" label-position="top">
          <el-form-item :label="$t('dms_stock_manage.chan_pin_xing_hao')">
            <custom-select url="productCodeSelectList" v-model="formSearch.productCode" :props="{ label: 'productCode', value: 'productCode' }" width="100%"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_stock_manage.zhan_dian')">
            <el-input v-model="formSearch.siteName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_stock_manage.shi_qu')">
            <custom-select type="tree" filterable v-model="formSearch.timezone" code="roc_timezone" :dataFilter="pathTransTree" :props="{ label: 'name', value: 'value' }"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_stock_manage.ku_cun_fang')">
            <el-input v-model="formSearch.orgName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_stock_manage.ru_ku_shi_jian')">
            <custom-date-picker
              style="width: 100%"
              @change="onPageChange({ page: 1 })"
              v-model="dataTimes"
              type="daterange"
              value-format="YYYY-MM-DD HH:mm:ss"
              :picker-options="beforeToday"
              :start-placeholder="$t('dms_stock_manage.kai_shi_ri_qi')"
              :end-placeholder="$t('dms_stock_manage.jie_shu_ri_qi')"
            ></custom-date-picker>
          </el-form-item>
        </el-form>
      </switch-container>
      <div class="table-bd">
        <custom-table
          tableCode="stockManage"
          ref="stock"
          :data="tableList"
          height="100%"
          @filter="filterChange"
          @sort="sortChange"
          @column="setColumn"
          :slots="['bodyNum', 'activateState', 'siteName', 'timezone', 'action']"
        >
          <template slot="bodyNum" slot-scope="scope">
            <div class="cell-link" @click="jump('/devicedetail', { deviceId: scope.row.deviceId, parentPath: $route.path })">{{ scope.row.bodyNum }}</div>
          </template>
          <template slot="activateState" slot-scope="scope">
            <el-popover v-if="scope.row.activateState === stateMap.activated" placement="top-start" trigger="hover">
              <ul>
                <li class="cell-pop-item">{{ $t('dms_stock_manage.ji_huoID') }}：{{ scope.row.activationId || '-' }}</li>
                <li class="cell-pop-item">{{ $t('dms_stock_manage.ji_huo_shi_jian') }}：{{ scope.row.lastActivationTime || '-' }}</li>
              </ul>
              <div class="cell-pop" slot="reference">{{ getDicValue('dms_device_activate_state', scope.row.activateState) }}</div>
            </el-popover>
            <div v-else>{{ getDicValue('dms_device_activate_state', scope.row.activateState) }}</div>
          </template>
          <template slot="siteName" slot-scope="scope">
            <el-popover v-if="scope.row.siteName" placement="top-start" trigger="hover">
              <ul>
                <li class="cell-pop-item">{{ $t('dms_stock_manage.zhan_dianID') }}：{{ scope.row.siteCode || '-' }}</li>
              </ul>
              <div class="cell-pop" slot="reference">{{ scope.row.siteName }}</div>
            </el-popover>
            <div v-else>{{ scope.row.siteName }}</div>
          </template>
          <template slot="timezone" slot-scope="scope">
            <el-popover v-if="scope.row.timezone" placement="top-start" trigger="hover">
              <ul>
                <li class="cell-pop-item">{{ $t('dms_stock_manage.Pagerpin_dao') }}：{{ scope.row.pagerChannel || '-' }}</li>
                <li class="cell-pop-item">{{ $t('dms_stock_manage.di_zhi') }}：{{ scope.row.siteAddress || '-' }}</li>
                <li class="cell-pop-item">{{ $t('dms_stock_manage.mo_ren_yu_yan') }}：{{ scope.row.defaultLocale || '-' }}</li>
              </ul>
              <div class="cell-pop" slot="reference">{{ scope.row.timezone }}</div>
            </el-popover>
            <div v-else>{{ scope.row.timezone }}</div>
          </template>
          <template slot="action" slot-scope="scope">
            <!-- 激活 -->
            <el-button type="text" size="mini" v-if="funcView.stock_device_activate && !scope.row.locationId" @click="onActiveConfirm(scope.row)">
              {{ funcView.stock_device_activate }}
            </el-button>
            <!-- 反激活 -->
            <el-button type="text" size="mini" v-if="funcView.stock_device_deactivate && scope.row.locationId" @click="onUnActiveConfirm(scope.row)">
              {{ funcView.stock_device_deactivate }}
            </el-button>
            <!-- 库存转移 -->
            <el-button type="text" size="mini" v-if="funcView.stock_device_transfer" @click="transferDialog(scope.row)">{{ funcView.stock_device_transfer }}</el-button>
            <!-- 更多操作 -->
            <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreAction">
              <el-button type="text" size="mini">
                <span>{{ $t('Common.com_more_action') }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- 绑定站点 暂时去掉 -->
                <!-- <el-dropdown-item
                  v-if="funcView.stock_bind_site && scope.row.productBrand === 'SBR' && scope.row.activateState == stateMap.activating"
                  @click.native="onConfirmGroup(scope.row)"
                >
                  {{ funcView.stock_bind_site }}{{ showMore(scope.row) }}
                </el-dropdown-item> -->
                <!-- 重新激活 暂时去掉-->
                <!-- <el-dropdown-item
                  v-if="funcView.stock_device_reactivate && scope.row.activateState == stateMap.deactivated && scope.row.activationId"
                  @click.native="onReActiveConfirm(scope.row)"
                >
                  {{ funcView.stock_device_reactivate }}{{ showMore(scope.row) }}
                </el-dropdown-item> -->
                <!-- 换机 -->
                <el-dropdown-item
                  v-if="funcView.stock_device_swap && !(userInfo.bizType === 'SC' && userInfo.rootOrgId == scope.row.orgId)"
                  @click.native="changeDeviceDialog(scope.row)"
                >
                  {{ funcView.stock_device_swap }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <!-- 更改站点 -->
                <el-dropdown-item v-if="funcView.stock_edit_site && scope.row.locationId" @click.native="onGroupDialog(scope.row)">
                  {{ funcView.stock_edit_site }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <!-- 升级站点 -->
                <el-dropdown-item v-if="funcView.stock_site_upgrade && scope.row.locationId && scope.row.createMode !== '2'" @click.native="onUploadDialog(scope.row)">
                  {{ funcView.stock_site_upgrade }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <!-- 解绑站点 -->
                <el-dropdown-item v-if="funcView.stock_unbind_site && scope.row.createMode === '2' && scope.row.locationId" @click.native="onUnbindSite(scope.row)">
                  {{ funcView.stock_unbind_site }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <!-- 关联开机卡 -->
                <el-dropdown-item v-if="funcView.stock_device_bind_card && scope.row.productBrand === 'ICE' && scope.row.cardClass == 1" @click.native="onBindCardDialog(scope.row)">
                  {{ funcView.stock_device_bind_card }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <!-- 开机设置密码 -->
                <el-dropdown-item v-if="funcView.stock_device_bind_card && scope.row.productBrand === 'ICE' && scope.row.cardClass == 2" @click.native="onOpenPwdDialog(scope.row)">
                  {{ $t('dms_stock_manage.she_zhi_kai_ji_mi_ma') }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <!-- 同步状态 暂时去掉 -->
                <!-- <el-dropdown-item
                  v-if="funcView.stock_refresh_status && scope.row.productBrand === 'SBR'"
                  @click.native="refreshStatus(scope.row)"
                >
                  {{ funcView.stock_refresh_status }}{{ showMore(scope.row) }}
                </el-dropdown-item> -->
                <!-- 设备报废 在库中就可以报废 在库中-10 stateDic.zkz 在库中-52 stateDic.ygj ICE设备才有 -->
                <el-dropdown-item v-if="funcView.stock_device_scrap && (`${scope.row.bizState}` === `${stateDic.zkz}`|| `${scope.row.bizState}` === `${stateDic.ygj}`) && scope.row.productBrand === 'ICE'" @click.native="onDeviceScrap(scope.row)">
                  {{ funcView.stock_device_scrap }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <!-- 更换零件 ICE设备才有 -->
                <el-dropdown-item v-if="funcView.stock_replace_parts && scope.row.productBrand === 'ICE'" @click.native="onReplaceParts(scope.row)">
                  {{ funcView.stock_replace_parts }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <!-- 设备翻新 -->
                <el-dropdown-item v-if="`${scope.row.allowRenovate}` === '1' && funcView.stock_device_renovate" @click.native="onDeviceRenovate(scope.row)">
                  {{ funcView.stock_device_renovate }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <!-- 设备允许总部翻新 -->
                <el-dropdown-item @click.native="allowDeviceRenovate(scope.row, 1)" v-if="`${scope.row.allowRenovate}` === '0' && funcView.allow_device_renovate">
                  {{ funcView.allow_device_renovate }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <el-dropdown-item @click.native="allowDeviceRenovate(scope.row, 0)" v-if="`${scope.row.allowRenovate}` === '1' && funcView.notallow_device_renovate">
                  {{ funcView.notallow_device_renovate }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <!-- 允许售后翻新 -->
                <el-dropdown-item @click.native="onRefurbishSc(scope.row, 1)" v-if="`${scope.row.allowRenovateSc}` === '0' && funcView.allow_device_renovate_sc">
                  {{ funcView.allow_device_renovate_sc }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <el-dropdown-item @click.native="onRefurbishSc(scope.row, 0)" v-if="`${scope.row.allowRenovateSc}` === '1' && funcView.notallow_device_renovate_sc">
                  {{ funcView.notallow_device_renovate_sc }}{{ showMore(scope.row) }}
                </el-dropdown-item>
                <!-- 迭代 2023.4 取消【销售机器】功能 -->
                <!-- <el-dropdown-item @click.native="onSaleDevice(scope.row)" v-if="scope.row.bizState != 52 && funcView.stock_device_sale">
                  {{ funcView.stock_device_sale }}{{ showMore(scope.row) }}
                </el-dropdown-item> -->
                <!-- 变更项目 -->
                <!-- <el-dropdown-item v-if="funcView.stock_device_modifyProject" @click.native="onProjectDialog(scope.row)">{{ funcView.stock_device_modifyProject }}</el-dropdown-item> -->
                <!-- 变更使用地点 -->
                <!-- <el-dropdown-item v-if="funcView.stock_device_usePlace" @click.native="onlocationDialog(scope.row)">{{ funcView.stock_device_usePlace }}</el-dropdown-item> -->
                <!-- 修改设备名称 -->
                <!-- <el-dropdown-item v-if="funcView.stock_device_rename" @click.native="onRenameDialog(scope.row)">{{ funcView.stock_device_rename }}</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <!-- 待入库 -->
    <stock-wait v-if="tab === '1'"></stock-wait>
    <!-- 转移设备/总部转移 -->
    <transfer-device-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList()"></transfer-device-dialog>
    <!-- 换机 -->
    <change-device-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getTableList()"></change-device-dialog>
    <!-- 批量转移设备-->
    <batch-transfer-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false" @success="getTableList()"></batch-transfer-dialog>
    <!-- 更改站点 -->
    <group-device-dialog v-if="dialogVisible4" :model="dialogModel4" @close="dialogVisible4 = false" @success="getTableList()"></group-device-dialog>
    <!-- 关联开机卡 -->
    <bind-opencard-dialog v-if="dialogVisible5" :model="dialogModel5" @close="dialogVisible5 = false" @success="getTableList()"></bind-opencard-dialog>
    <!-- 开机密码 -->
    <bind-openpwd-dialog v-if="dialogVisible14" :model="dialogModel14" @close="dialogVisible14 = false" @success="getTableList()"></bind-openpwd-dialog>
    <!-- 激活 -->
    <location-site-select-dialog v-if="dialogVisible6" :model="dialogModel6" @close="dialogVisible6 = false" @success="onActiveSuccess"></location-site-select-dialog>
    <!-- 升级站点 -->
    <website-dialog v-if="dialogVisible7" :model="dialogModel7" @close="dialogVisible7 = false" @success="getTableList()"></website-dialog>
    <!-- 变更项目 -->
    <device-project-dialog v-if="dialogVisible8" :model="dialogModel8" @close="dialogVisible8 = false" @success="getTableList()"></device-project-dialog>
    <!-- 使用地点 -->
    <device-location-dialog v-if="dialogVisible9" :model="dialogModel9" @close="dialogVisible9 = false" @success="getTableList()"></device-location-dialog>
    <!-- 修改设备名称 -->
    <device-rename-dialog v-if="dialogVisible10" :model="dialogModel10" @close="dialogVisible10 = false" @success="getTableList()"></device-rename-dialog>
    <!--设备报废 -->
    <device-scrap-dialog v-if="dialogVisible11" :model="dialogModel11" @close="dialogVisible11 = false" @success="getTableList()"></device-scrap-dialog>
    <!--更换零件 -->
    <replace-parts-dialog v-if="dialogVisible12" :model="dialogModel12" @close="dialogVisible12 = false" @success="getTableList()"></replace-parts-dialog>
    <!--批量翻新 -->
    <renovate-batch-dialog v-if="dialogVisible13" :model="dialogModel13" @close="dialogVisible13 = false" @success="getTableList()"></renovate-batch-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import websiteDialog from '@/pages/dms/components/websiteDialog.vue';
import groupDeviceDialog from '@/pages/dms/components/groupDeviceDialog.vue';
import bindOpencardDialog from '@/pages/dms/components/bindOpencardDialog.vue';
import deviceProjectDialog from '@/pages/dms/components/device_project_dialog.vue';
import deviceLocationDialog from '@/pages/dms/components/device_location_dialog.vue';
import deviceRenameDialog from '@/pages/dms/components/device_rename_dialog.vue';
import changeDeviceDialog from '@/pages/dms/components/changeDeviceDialog.vue';
import locationSiteSelectDialog from '@/pages/dms/components/location_site_select_dialog.vue';
import bindOpenpwdDialog from '@/pages/dms/components/bindOpenpwdDialog.vue';
import stockWait from './children/stock_wait.vue';
import transferDeviceDialog from './children/transfer_device_dialog.vue';
import batchTransferDialog from './children/batch_transfer_dialog.vue';
import deviceScrapDialog from './children/device_scrap_dialog.vue';
import replacePartsDialog from './children/replace_parts_dialog.vue';
import renovateBatchDialog from './children/renovate_batch_dialog.vue';

export default {
  name: 'stockManage',
  components: {
    stockWait,
    websiteDialog,
    locationSiteSelectDialog,
    transferDeviceDialog,
    changeDeviceDialog,
    batchTransferDialog,
    groupDeviceDialog,
    bindOpencardDialog,
    deviceProjectDialog,
    deviceLocationDialog,
    deviceRenameDialog,
    deviceScrapDialog,
    replacePartsDialog,
    renovateBatchDialog,
    bindOpenpwdDialog,
  },
  data() {
    return {
      provide: true,
      moreAction: [],
      stateDic: {},
      stateMap: {},
      dataTimes: [],
      formSearch: {
        stockInState: '2',
        productCode: '',
        siteName: '',
        orgName: '',
        // shipperOrgName: '',
        // operator: '',
        timezone: [],
        startTime: '',
        endTime: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },
      // tabList: [{ name: '', value: '2' }, { name: '', value: '1' }],
      tab: '2',
      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible3: false,
      dialogModel3: {},
      dialogVisible4: false,
      dialogModel4: {},
      dialogVisible5: false,
      dialogModel5: {},
      dialogVisible6: false,
      dialogModel6: {},
      dialogVisible7: false,
      dialogModel7: {},
      dialogVisible8: false,
      dialogModel8: {},
      dialogVisible9: false,
      dialogModel9: {},
      dialogVisible10: false,
      dialogModel10: {},
      dialogVisible11: false,
      dialogModel11: {},
      dialogVisible12: false,
      dialogModel12: {},
      dialogVisible13: false,
      dialogModel13: {},
      dialogVisible14: false,
      dialogModel14: {},
      link: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo || {};
    },
    tabList(vm) {
      const tab = [];
      if (vm.funcView.stock_device_list) {
        tab.push({ name: this.$t('dms_stock_manage.yi_ru_ku'), value: '2' });
      }
      if (vm.funcView.be_stock_device_list) {
        tab.push({ name: this.$t('dms_stock_manage.dai_ru_ku'), value: '1' });
      }
      return tab;
    },
  },
  activated: function () {
    this.getTableList();
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.clearKeepAlive('stockRecord');

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    // this.getTableList();
    this.getDictionary('order_device_biz_state,dms_device_activate_state', (data) => {
      this.stateDic = this.$transformDicCode(data.order_device_biz_state);
      this.stateMap = this.$listTransObject(data.dms_device_activate_state, 'code', 'value');
    });
  },
  methods: {
    // 更多操作
    showMore: function (row) {
      this.$set(row, 'showMoreAction', true);
      return '';
    },
    // 路径字符串转树
    pathTransTree(arr) {
      let list = arr.map(t => t.value);
      list = list.map(t => t.split('/').map((f, i) => ({ name: f, value: f, parent: i ? t.split('/')[i - 1] : 0 })));
      list = list.reduce((pre, item) => [...pre, ...item], []);
      list = [...new Set(list.map(t => JSON.stringify(t)))].map(f => JSON.parse(f));
      const tree = list.filter((parent) => {
        const branchArr = list.filter(child => parent.name === child.parent);
        if (branchArr.length > 0) {
          parent.children = branchArr;
        }
        return parent.parent === 0;
      });
      return tree;
    },
    // 切换tab
    changeTab: function () {
      this.tableList = [];
      this.totalRows = null;
      this.onPageChange({ page: 1 });
    },
    // 获取表格数据列表
    getTableList: function () {
      const timezone = this.formSearch.timezone.join('/');
      this.formSearch.startTime = this.dataTimes ? this.dataTimes[0] : '';
      this.formSearch.endTime = this.dataTimes ? this.dataTimes[1] : '';
      this.$getJSON(apis.stockDevicePage, { ...this.formSearch, timezone }).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清空
    clearFilter: function () {
      this.dataTimes = [];
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    // 批量转移
    batchTransferDialog: function () {
      this.dialogModel3.title = this.$t('dms_stock_manage.pi_liang_zhuan_yi');
      this.dialogModel3.type = this.userInfo.bizType === 'HQ' ? 'hq' : '';
      this.dialogModel3.row = this.userInfo;
      this.dialogVisible3 = true;
    },
    // 转移
    transferDialog: function (row) {
      this.dialogModel = {
        title: this.$t('dms_stock_manage.she_bei_zhuan_yi'),
        row: row,
        type: this.userInfo.bizType === 'HQ' && this.userInfo.rootOrgId === row.orgId ? 'hq' : '',
      };
      this.dialogVisible = true;
    },
    // 换机
    changeDeviceDialog: function (row) {
      this.dialogModel1 = { title: this.$t('dms_stock_manage.huan_ji'), row: row };
      this.dialogVisible1 = true;
    },
    // 更改站点
    onGroupDialog: function (row) {
      this.dialogModel4 = { title: this.$t('dms_stock_manage.geng_gai_qu_yu'), row };
      this.dialogVisible4 = true;
    },
    // 解绑站点
    onUnbindSite: function (row) {
      const tips = this.$t('dms_stock_manage.nqdyjbzdm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.stockUnBindSite}/${row.bodyNum}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 销售机器
    onSaleDevice: function (row) {
      const tips = this.$t('dms_stock_manage.nqdgjqyjxsm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.stockDeviceSale, { bodyNum: row.bodyNum }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 关联开机卡
    onBindCardDialog: function (row) {
      this.dialogModel5 = { title: this.$t('dms_stock_manage.guan_lian_kai_ji_kao', [row.bodyNum]), row };
      this.dialogVisible5 = true;
    },
    // 开机密码
    onOpenPwdDialog: function (row) {
      this.dialogModel14 = { title: this.$t('dms_stock_manage.kai_ji_mi_ma'), row };
      this.dialogVisible14 = true;
    },
    // 站点升级
    onUploadDialog: function (row) {
      this.dialogModel7 = { title: this.$t('dms_stock_manage.sheng_ji_zhan_dian'), type: 'update', row };
      this.dialogVisible7 = true;
    },
    // 绑定站点
    onConfirmGroup: function (row) {
      const tips = this.$t('dms_stock_manage.nqdybdzdm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.stockBindSite, { bodyNum: row.bodyNum }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 激活
    onActiveConfirm: function (row) {
      const title = this.$t('dms_stock_manage.she_bei_ji_huo');
      this.dialogModel6 = { title, row };
      this.dialogVisible6 = true;
    },
    // 激活成功
    onActiveSuccess: function (form) {
      this.$postJSON(apis.stockActivate, {
        bodyNum: form.row.bodyNum,
        locationId: form.locationId,
        siteId: form.siteId
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success'
        });
        this.getTableList();
      });
    },
    // 反激活
    onUnActiveConfirm: function (row) {
      const tip = this.$t('dms_stock_manage.nqdyfjhxzdsbbksyspan');
      this.$showConfirm(tip, null, {
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.$postJSON(apis.stockDeactivate, { bodyNum: row.bodyNum }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 重新激活
    onReActiveConfirm: function (row) {
      const tip = this.$t('dms_stock_manage.nqdycxjhxzdydtsjspan');
      this.$showConfirm(tip, null, {
        dangerouslyUseHTMLString: true,
      })
        .then(() => {
          this.$postJSON(apis.stockReactivate, { bodyNum: row.bodyNum }).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 同步状态
    refreshStatus: function (row) {
      const tips = this.$t('dms_stock_manage.nqdytbxzdszxztxxspan');
      this.$showConfirm(tips, null, {
        dangerouslyUseHTMLString: true,
      }).then(() => {
        this.$postJSON(`${apis.ProductActiva}/${row.bodyNum}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    // 修改项目
    onProjectDialog: function (row) {
      this.dialogModel8.title = this.$t('dms_stock_manage.bian_geng_xiang_mu');
      this.dialogModel8.data = row;
      this.dialogVisible8 = true;
    },
    // 使用地点
    onlocationDialog: function (row) {
      this.dialogModel9.title = this.$t('dms_stock_manage.bgsydd');
      this.dialogModel9.data = row;
      this.dialogVisible9 = true;
    },
    // 修改设备名称
    onRenameDialog: function (row) {
      this.dialogModel10.title = this.$t('dms_stock_manage.xgsbmc');
      this.dialogModel10.data = row;
      this.dialogVisible10 = true;
    },
    // 申请报废
    onDeviceScrap: function (row) {
      this.dialogModel11.title = this.$t('dms_stock_manage.sqsbbf');
      this.dialogModel11.data = row;
      this.dialogVisible11 = true;
    },
    // 更换零件
    onReplaceParts: function (row) {
      this.dialogModel12.title = this.$t('dms_stock_manage.geng_huan_ling_jian');
      this.dialogModel12.data = row;
      this.dialogVisible12 = true;
    },
    // 批量翻新
    batchRenovateDialog: function () {
      this.dialogModel13.title = this.$t('dms_stock_manage.pi_liang_zhuan_yi');
      this.dialogVisible13 = true;
    },
    // 设备翻新
    onDeviceRenovate: function (row) {
      const tips = this.$t('dms_stock_manage.nqdyfxxzdsbm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.renovate}/${row.deviceId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 设置是否允许总部翻新
    allowDeviceRenovate: function (row, allow) {
      const tips = this.$t('dms_stock_manage.nqdyyxgsbfxm');
      const tips1 = this.$t('dms_stock_manage.nqdyjzgsbfxm');
      this.$showConfirm(allow ? tips : tips1)
        .then(() => {
          this.$postJSON(`${apis.AllowRenovateDevice}/${row.deviceId}/${allow}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 售后翻新
    onRefurbishSc(row, allow) {
      const { productCode, bodyNum, deviceId } = row;
      const tpl = this.$t('dms_stock_manage.nqdyfxgoodsbm', [productCode,bodyNum]);
      const tpl1 = this.$t('dms_stock_manage.nqdyjzfxoodsbm', [productCode,bodyNum]);
      this.$showConfirm(allow ? tpl : tpl1)
        .then(() => {
          this.$postJSON(`${apis.allowScRenovate}/${deviceId}/${allow}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 数据导出
    exportTable: function () {
      const timezone = this.formSearch.timezone.join('/');
      this.$exportFlie(apis.stockExport, { ...this.formSearch, timezone }).then(() => {});
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.stock-manage-bd {
  .stock-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    overflow: hidden;
  }
}
</style>
